import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { RootState } from "../../redux/store";
import { Alert, Button, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToggle, useViewport } from "../../hooks";
import { getToken, logout } from "../../helpers/api/authService";
import { changeSideMenuMobileMode } from "../../helpers/utility";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import PharmacyGroupDropdown from "./PharmacyGroupDropdown";
import { toggleSideMenu, toggleSideMenuMobile } from "redux/layouts/NavSlice";
import { decodeToken } from "helpers/api/authService";
import { getAccountDetails } from "redux/slices/Accounts";
import { getUser, getUserDetails } from "redux/slices/User";
import { UserGuide } from "./UserGuide";
import axios from "axios";
import { showToast } from "redux/slices/Toasts";
import { ZIcon } from "components/ZIcon";
import { ZIconType } from "helpers/utility/iconMap";
import { GetStoreGroupSetting, ManagedCatalogueSetting, getFeatureFlags, updateStoreGroupField } from "redux/slices/Global";
import { ChangelogLink } from "constants/links";
import { MOBILE_WIDTH_THRESHOLD } from "layouts/Layout";
import { getStockConflicts } from "redux/slices/Stocks";
import { getFeatureFlagValue } from "components/ZFeatureFlag";

type TopbarProps = {
    hideLogo?: boolean;
    navCssClasses?: string;
    openLeftMenuCallBack?: () => void;
    topbarDark?: boolean;
    pharmacyGroupMenu: boolean;
};
declare const heap: any;
const Topbar = ({ hideLogo, navCssClasses, openLeftMenuCallBack, topbarDark, pharmacyGroupMenu }: TopbarProps) => {

    const containerCssClasses = !hideLogo ? "container-fluid" : "";
    const dispatch = useAppDispatch();
    const [isOpenDropdown, toggleDropdown] = useToggle();
    const navigate = useNavigate();
    const { width } = useViewport();
    const account = useAppSelector((state: RootState) => state.account);
    const permissions = useAppSelector((state: RootState) => state.permissions);
    const user = useAppSelector((state: RootState) => state.logedinUser);
    const isOpenSideMenu = useAppSelector((state: RootState) => state.menuToggle.isSideMenuMobileOpen);
    const global = useAppSelector((state: RootState) => state.global);
    const [heapSet, setHeapSet] = useState<boolean>(false);
    const serverSideEvents = useRef();
    

    const handleLeftMenuCallBack = () => {
        if (width >= MOBILE_WIDTH_THRESHOLD) {
            dispatch(toggleSideMenu());
        } else {
            changeSideMenuMobileMode(isOpenSideMenu);
            dispatch(toggleSideMenuMobile());
        }
    };

    useEffect(() => {
        const authData: any = decodeToken();
        // App startup can render once before auth bootstrap finishes, so avoid dereferencing a temporary null token.
        if (authData == null) {
            return;
        }
        dispatch(getUser());
        dispatch(getAccountDetails(authData.UserId));
        dispatch(getUserDetails());
        let interval: NodeJS.Timeout | null = null;
        dispatch(getFeatureFlags()).then(() => {
            if (getFeatureFlagValue(global.featureFlags, "ZFreedom.ManagedStock.StockConflicts") === true) {
                reloadConflicts();
                interval = setInterval(() => {
                    reloadConflicts();
                }, 1000 * 60 * 30);
            }
        });

        dispatch(GetStoreGroupSetting("managedCatalogue_migration")).then((res) => {
            const promptShown = JSON.parse(res.data.jsonSettings) as ManagedCatalogueSetting;
            if (promptShown){
                dispatch(updateStoreGroupField({ key: "managedCatalogue", value: promptShown }))
            }
        });

        initialiseSSE();
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        }
    }, []);

    useEffect(()=>{
        if(heapSet || global == null || global.storeGroupId == 0){
            return;
        }
        try {
            if (typeof heap !== 'undefined' && user != null) {          
                heap.identify(user.id);
                heap.addUserProperties({
                    Name: user.givenName + " " + user.familyName, 
                    "email": user.email,
                    StoreGroupId: global.storeGroupId,
                    StoreGroupName: global.storeName     
                });

                setHeapSet(true);
            }
        } catch (error) {
            console.log(error);   
        }
    },[user, global.storeGroupId])

    async function initialiseSSE() {
        fetch(axios.defaults.baseURL + `api/v1/Notifications/live`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
            .then(response => {
                if (response.ok && response.body) {
                    let reader = response.body.pipeThrough(new TextDecoderStream()).getReader();

                    const readStream:any = () =>
                        reader.read().then(({
                            value,
                            done
                        }) => {
                            if (done) {
                                reader.cancel();
                                return Promise.resolve();
                            }

                            // parse the data
                            const data = /{.*}/.exec(value);
                            if (!data || !data[0]) {
                                return readStream();
                            }

                            const res = JSON.parse(data[0]);

                            console.log(res);

                            if (res.action == 'notification') {
                                dispatch(showToast({ value: res.messages }));
                            }

                            // do something if success
                            // and cancel the stream 
                            // reader.cancel().catch(() => null);

                            return readStream();
                        });
                    return readStream();
                } else {
                    return Promise.reject(response);
                }
            })
    }

    async function reloadConflicts() {
        const stockConflicts = await dispatch(getStockConflicts({countOnly: true}));
        dispatch(updateStoreGroupField({ key: "numStockConflicts", value: (stockConflicts.totalRows ?? 0) }));
    }

    return (
        <div className={classNames("navbar-custom", navCssClasses)}>
            <div className={containerCssClasses}>
                <ul className="list-unstyled topbar-menu float-end mb-0">
                    {pharmacyGroupMenu && <>
                        <li className="dropdown notification-list">
                            <div className="d-flex align-items-center gap-2">
                                <span className="d-inline-flex" style={{ height: "60px"}}><Button variant="light" className="whatsnew p-0 px-1 gap-1" onClick={() => 
                                    window.open(ChangelogLink)
                                }>
                                    <i className="mdi mdi-bullhorn-variant"></i>
                                    <p className="m-0 d-none d-sm-flex">What's New</p>
                                </Button></span>
                            </div>
                        </li>
                        <li className="dropdown notification-list">
                            <UserGuide />
                        </li>
                    </>
                    }

                    <li className="dropdown notification-list">
                        <Dropdown show={isOpenDropdown} onToggle={toggleDropdown}>
                            <Dropdown.Toggle variant="link" id="dropdown-profile" as={Link} to="#" onClick={toggleDropdown} className="nav-link dropdown-toggle nav-user arrow-none me-0 ms-2">
                                <span className="account-user-avatar">
                                    <i className="rounded-circle mdi mdi-account-circle mdi-25px"></i>
                                </span>
                                <span>
                                    <span className="account-user-name">{user.givenName}</span>
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu align={"end"} className="topbar-dropdown-menu profile-dropdown">
                                <div onClick={toggleDropdown}>
                                    <Link to="/login" className="dropdown-item notify-item" onClick={() => {
                                        logout();
                                    }}>
                                        <i className="mdi mdi-logout me-1"></i>
                                        <span>Logout</span>
                                    </Link>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                </ul>
                
                <button className="button-menu-mobile open-left px-0" onClick={handleLeftMenuCallBack}><i className="mdi mdi-menu" /></button>
                <ul className="list-unstyled topbar-menu mb-0">
                {pharmacyGroupMenu && 
                    <>
                        <li className="">
                            <PharmacyGroupDropdown />
                        </li>
                    </>
                }
                </ul>
            </div>
        </div>
    );
};
export default Topbar;